let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("hRogs")).then(() => parcelRequire('9o9JR'));